import { COURSE_SERVICE_ENV } from '../environments'; 

/**
 * Attempts to build the base URL used for accessing courses.
 * 
 * At the moment, the returned value will probably match the domain of the
 * site, but in case that ever changes, this function can simply be adjusted
 * a bit.
 * 
 * @param {string} environment - The environment to build the path for.
 * @returns {string}
 */
export function getCourseBasePath( environment ) {
    return `https://${ window.location.hostname }/`;
}

/**
 * Attempts to build the URL to access a single course. If the provided path
 * doesn't include a domain and is a relative path, the site's domain will be
 * added to the front of the path.
 * 
 * Example: http://qa.biwlearning-hoya.com/lms/basicoptics-anatomyoftheeye-prod/index.html
 * 
 * @param {string} path - The path of the target course. This will be placed at the end of the 
 * @returns {string}
 */
export const buildCoursePath = ( path ) => {
    if ( !path ) {
        return undefined;
    }

    let finalPath = undefined;
    const isRelative = !( /^https?:\/\//i ).test( path );

    if ( !isRelative ) {
        finalPath = path;
    } else {
        // Remove '/' from the front of the relative path if it exists for combining
        // with the base path. Also, add the 'lms/' to the relative path in case it
        // isn't there since that's where all of the courses currently are.
        let relativePath = ( path?.charAt( 0 ) === '/' ) ? path?.substr( 1 ) : path;
        const containsLms = ( /^lms\//i ).test( relativePath );
        if ( !containsLms ) {
            relativePath = `lms/${ relativePath }`;
        }

        // Assemble final URL for the course.
        const basePath = getCourseBasePath( COURSE_SERVICE_ENV );
        finalPath = `${ basePath }${ relativePath }`;
    }

    return finalPath;
};
